import { StoreForms } from './state'

export const getKeyByForm = (idForm: string) => {
  const forms = {
    companies: 'EntryId',
    companyInfo: 'EntryId',
  }
  return forms[idForm] || 'EntryId'
}

type IRelation = {
  [key in StoreForms]?: {
    [key in StoreForms]?: {
      fieldLink: string
    }
  }
}

export const relations = (idForm: string): IRelation => {
  const relations: IRelation = {}

  return relations[idForm]
}
